import React, {Fragment} from "react";
import {sprintf} from "sprintf-js";
import {Card, CardContent, Grid, Typography} from "@mui/material";
import {ChecklistField, LeadChecklistField} from "../formFields/ChecklistField";
import ChecklistItemDefault from "../defaults/ChecklistItemDefault";

const [section, name] = [2, "Kitchen"];

const KitchenDefaults = () => {
    return {
        "2": {
            "1": ChecklistItemDefault,
            "2": ChecklistItemDefault,
            "3": ChecklistItemDefault,
            "4": ChecklistItemDefault,
            "5": ChecklistItemDefault,
            "6": ChecklistItemDefault,
            "7": ChecklistItemDefault,
            "8": ChecklistItemDefault,
            "9": ChecklistItemDefault,
            "10": ChecklistItemDefault,
            "11": ChecklistItemDefault,
            "12": ChecklistItemDefault,
            "13": ChecklistItemDefault
        }
    };
};

const Kitchen = () => {
    const relPath = "Kitchen";
    return (
        <Fragment>
                <Card>
                    <CardContent>
                        <Typography variant={"h6"} gutterBottom>
                            {sprintf("%d. %s", section, name)}
                        </Typography>
                        <Grid container spacing={3}>
                            <ChecklistField
                                path={sprintf("%s.%s", relPath, "present")}
                                rank={"2.1"}
                                room={name}
                                desc={"Kitchen Present"}
                                section={section}
                            />
                        </Grid>
                        <Grid container spacing={3}>
                            <ChecklistField
                                path={sprintf("%s.%s", relPath, "electricity")}
                                rank={"2.2"}
                                room={name}
                                desc={"Electricity"}
                                section={section}
                            />
                        </Grid>
                        <Grid container spacing={3}>
                            <ChecklistField
                                path={sprintf("%s.%s", relPath, "electricalHazard")}
                                rank={"2.3"}
                                room={name}
                                desc={"Free of Electrical Hazards"}
                                section={section}
                            />
                        </Grid>
                        <Grid container spacing={3}>
                            <ChecklistField
                                path={sprintf("%s.%s", relPath, "security")}
                                rank={"2.4"}
                                room={name}
                                desc={"Security"}
                                section={section}
                            />
                        </Grid>
                        <Grid container spacing={3}>
                            <ChecklistField
                                path={sprintf("%s.%s", relPath, "windowCondition")}
                                rank={"2.5"}
                                room={name}
                                desc={"Window Condition"}
                                section={section}
                            />
                        </Grid>
                        <Grid container spacing={3}>
                            <ChecklistField
                                path={sprintf("%s.%s", relPath, "ceilingCondition")}
                                rank={"2.6"}
                                room={name}
                                desc={"Ceiling Condition"}
                                section={section}
                            />
                        </Grid>
                        <Grid container spacing={3}>
                            <ChecklistField
                                path={sprintf("%s.%s", relPath, "wallCondition")}
                                rank={"2.7"}
                                room={name}
                                desc={"Wall Condition"}
                                section={section}
                            />
                        </Grid>
                        <Grid container spacing={3}>
                            <ChecklistField
                                path={sprintf("%s.%s", relPath, "floorCondition")}
                                rank={"2.8"}
                                room={name}
                                desc={"Floor Condition"}
                                section={section}
                            />
                        </Grid>
                        <Grid container spacing={3}>
                            <LeadChecklistField
                                path={sprintf("%s.%s", relPath, "leadPaint")}
                                rank={"2.9"}
                                room={name}
                                desc={"Lead-Based Paint"}
                                section={section}
                            />
                        </Grid>
                        <Grid container spacing={3}>
                            <ChecklistField
                                path={sprintf("%s.%s", relPath, "stoveRange")}
                                rank={"2.10"}
                                room={name}
                                desc={"Stove or Range with Oven"}
                                section={section}
                            />
                        </Grid>
                        <Grid container spacing={3}>
                            <ChecklistField
                                path={sprintf("%s.%s", relPath, "refrigerator")}
                                rank={"2.11"}
                                room={name}
                                desc={"Refrigerator"}
                                section={section}
                            />
                        </Grid>
                        <Grid container spacing={3}>
                            <ChecklistField
                                path={sprintf("%s.%s", relPath, "sink")}
                                rank={"2.12"}
                                room={name}
                                desc={"Sink"}
                                section={section}
                            />
                        </Grid>
                        <Grid container spacing={3}>
                            <ChecklistField
                                path={sprintf("%s.%s", relPath, "storageSpace")}
                                rank={"2.13"}
                                room={name}
                                desc={"Space for storage, preparation, and serving of food"}
                                section={section}
                            />
                        </Grid>
                    </CardContent>
                </Card>
        </Fragment>
    );
};

export default Kitchen;
export {KitchenDefaults};